export const state = {
    /**
    * --------------------------------------------------------------------------
    * State Language Lines
    * --------------------------------------------------------------------------
    *
    * The following language lines are used by State management system to build 
    * form, grid and other related places where tample related labels required.
    * You are free to change them to anything
    * you want to customize your views to better match your application.
    * 
    */
    en: {
        state:'State',
        state_id:'State Id',
        state_management:'State Management',
        add_state:'Add State',
        edit_state:'Edit State',
        cancel:'cancel',
        submit:'submit',
        state_information:'State Information',
        state_name:'State Name',
        country:'country',
        state_status:'State Status',
        country_name:'Country Name',
        delete_confrim_msg:"Are you sure you want to delete this state list?",
    },

    ar: {
        state:'الحالة',
        state_id:'معرف الولاية',
        state_management:'إدارة الدولة',
        add_state:'أضف دولة',
        edit_state:'تحرير الدولة',
        cancel:'إلغاء',
        submit:'إرسال',
        state_information:'معلومات الدولة',
        state_name:'اسم الولاية',
        country:'البلد',
        state_status:'وضع الدولة',
        country_name:'اسم الدولة',
        delete_confrim_msg:"هل أنت متأكد أنك تريد حذف قائمة الحالات هذه؟",
    }
}